import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CONTACT_CONFIG } from './contact.config';

export default function MContactAddress({ className }) {
	return (
		<article className={`m-contact m-contact--address ${className}`}>
			<p className="label">
				<FormattedMessage id="CONTACT_ADDRESS.FIND_US" defaultMessage="" />
			</p>
			<address>
				<p className="title">{CONTACT_CONFIG.address.title}</p>
				<p>{CONTACT_CONFIG.address.street}</p>
				<p>{CONTACT_CONFIG.address.city}</p>
				<p>{CONTACT_CONFIG.address.country}</p>
			</address>
		</article>
	);
}




// WEBPACK FOOTER //
// ./src/components/molecules/contact/_molecules.contact-address.js